import type { CommentListOrder } from '@/@types/comment'
import { css } from '@emotion/react'
import { CaretDownIcon } from '@ruguoapp/jike-fe-icons'
import type { HTMLAttributes } from 'react'
import ClickWrapper, { type ClickWrapperProps } from '../ClickWrapper'
import DropdownMenu from '../DropdownMenu/DropdownMenu'

const COMMENT_ORDER_LOCALE: Record<CommentListOrder, string> = {
	LIKES: '智能排序',
	TIME: '时间排序',
}

export interface CommentListOrderSelectProps
	extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
	value?: CommentListOrder
	onChange?: (value: CommentListOrder) => void
}

export default function CommentListOrderSelect({
	value = 'LIKES',
	onChange,
	...props
}: CommentListOrderSelectProps) {
	return (
		<DropdownMenu
			renderTrigger={(triggerProps) => (
				<ClickWrapper
					{...(triggerProps as ClickWrapperProps)}
					css={css`
						display: flex;
						align-items: center;
						gap: 4px;
						cursor: pointer;
						user-select: none;
					`}
				>
					<CaretDownIcon
						color="currentColor"
						css={css`
							width: 16px;
							height: 16px;
						`}
					/>
					{COMMENT_ORDER_LOCALE[value]}
				</ClickWrapper>
			)}
			data={Object.entries(COMMENT_ORDER_LOCALE).map(([key, title]) => ({
				id: key,
				title: title,
			}))}
			position="bottom-end"
			onSelect={(menuId) => onChange?.(menuId as CommentListOrder)}
		/>
	)
}
